<template>
  <div v-if="internalValue">
    <div class="form-row">
      <div class="col-lg-4 col-md-6 col-form-label pt-0 pb-0">
        <div class="form-group">
          <label for="Phone">
            {{ $t('Webportal.SupportInformation.Telephone') }}</label>
        </div>

        <div class="form-group">
          <label for="Reachability">
            {{ $t('Webportal.SupportInformation.Reachability') }}</label>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="form-group">
          <b-form-input id="Phone" v-model="internalValue.Phone" size="sm" :disabled="isFieldDisabled('IsPhoneEnabled')"
            :state="validationFields['SupportInformationPhone']?.valid == false ? false : null" trim
            v-validate="{ regex: /^[0-9-+]*$/ }" data-vv-name="SupportInformationPhone">
          </b-form-input>
        </div>
        <div class="form-group">
          <b-form-input id="Reachability" v-model="internalValue.Reachability" size="sm"
            :disabled="isFieldDisabled('IsPhoneEnabled')" v-validate data-vv-name="SupportInformationReachability">
          </b-form-input>
        </div>
      </div>
      <label class="col-auto align-self-center">
        {{ $t('Webportal.Visible') }}
        <font-awesome-icon :icon="['fas', 'eye']" />
      </label>
      <div class="col-auto align-self-center">
        <label class="switch switch-label switch-secondary">
          <input class="switch-input" type="checkbox" :checked="getEnabledValue('IsPhoneEnabled')"
            @input="setEnabledValue('IsPhoneEnabled', $event.target.checked)" v-validate data-vv-name="IsPhoneEnabled"
            :disabled="disabled">
          <span class="switch-slider" data-checked="On" data-unchecked="Off"></span>
        </label>
      </div>
    </div>

    <div class="form-group form-row">
      <label for="EMail" class="col-lg-4 col-md-6 col-form-label pt-0">
        {{ $t('Webportal.SupportInformation.EMail') }}</label>
      <div class="col-lg-4 col-md-6">
        <b-form-input id="EMail" v-model="internalValue.EMail"
          :state="validationFields['SupportInformationEMail']?.valid == false ? false : null" trim size="sm"
          :disabled="isFieldDisabled('IsEMailEnabled')" v-validate="'email'" data-vv-name="SupportInformationEMail">
        </b-form-input>
      </div>
      <label class="col-auto">
        {{ $t('Webportal.Visible') }}
        <font-awesome-icon :icon="['fas', 'eye']" />
      </label>
      <div class="col-auto">
        <label class="switch switch-label switch-secondary">
          <input class="switch-input" type="checkbox" :checked="getEnabledValue('IsEMailEnabled')"
            @input="setEnabledValue('IsEMailEnabled', $event.target.checked)" v-validate data-vv-name="IsEMailEnabled"
            :disabled="disabled">
          <span class="switch-slider" data-checked="On" data-unchecked="Off"></span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SupportInformation',

  inject: {
    $validator: 'parentValidator'
  },

  props: {
    value: { type: Object, default: {} },
    disabled: { type: Boolean, default: false }
  },

  data() {
    return {
      internalValue: this.value ?? {}
    };
  },

  computed: {
    isEmailValid() {
      if (this.internalValue?.EMail && this.validationFields["EMail"])
        return this.validationFields["EMail"].valid;
    },

    isFormValid() {
      return Object.keys(this.validationFields).every(
        (key) =>
          this.validationFields[key].valid === null ||
          this.validationFields[key].valid
      );
    },
  },

  watch: {
    value(newVal, oldVal) {
      this.internalValue = newVal ?? {};
    },

    internalValue(newVal, oldVal) {
      this.$emit("input", newVal);
    }
  },

  methods: {
    isFieldDisabled(settingName) {
      return this.disabled || this.getEnabledValue(settingName) == false;
    },

    getEnabledValue(settingName) {
      return this.internalValue[settingName] ?? true;
    },

    setEnabledValue(settingName, newValue) {
      this.internalValue[settingName] = newValue;
      this.validationFields[settingName].dirty = true;
    }
  }
}
</script>